export default "__VITE_ASSET__CNTEJyfr__"